export const DURATIONS: { [key: string]: string } = {
  "15": "15 min",
  "30": "30 min",
  "60": "1 hr",
}